import { useState, useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ReactBSAlert from "react-bootstrap-sweetalert";
import { makeStyles } from "@material-ui/core/styles";
import { Card, CardContent, Container, Typography } from "@material-ui/core";

import componentStyles from "assets/theme/views/auth/login.js";
import componentStylesButtons from "assets/theme/components/button.js";
import Api from "lib/api/httpRequestHelper.js";
import UtilsFncs from "utils/UtilsFncs";
import MaskAndValid from "utils/maskAndValid";

const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(componentStylesButtons);

function Alert({ text }) {
  return (
    <ReactBSAlert
      success
      style={{ display: "block", marginTop: "-100px" }}
      title="Usuário ativado com sucesso!"
      onConfirm={UtilsFncs?.RedirectToLoginPage}
      onCancel={UtilsFncs?.RedirectToLoginPage}
      confirmBtnBsStyle="info"
      confirmBtnText="Ok"
      btnSize=""
      confirmBtnStyle={{
        marginRight: undefined,
        borderColor: undefined,
        boxShadow: undefined,
      }}
    >
      {text}
    </ReactBSAlert>
  );
}

function AlertError({ text }) {
  return (
    <ReactBSAlert
      error
      style={{ display: "block", marginTop: "-100px" }}
      title="Ops!"
      onConfirm={UtilsFncs?.RedirectToLoginPage}
      onCancel={UtilsFncs?.RedirectToLoginPage}
      confirmBtnBsStyle="info"
      confirmBtnText="Ok"
      btnSize=""
      confirmBtnStyle={{
        marginRight: undefined,
        borderColor: undefined,
        boxShadow: undefined,
      }}
    >
      {text}
    </ReactBSAlert>
  );
}

function ActivateUser() {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setalert] = useState(false);
  const location = useLocation();

  const checkTokenAndEmail = useCallback(async (email, token) => {
    await Api.get(
      "activate-user",
      "login",
      "?email=" + email + "&token=" + token,
      false
    )
      .then(({ Success }) => {
        if (Success) {
          setalert(
            <Alert
              text={"Clica em OK para ser redirecionado para a tela de login"}
            />
          );
        } else {
          setalert(
            <AlertError
              text={
                "Ocorreu um erro ao ativar usuário. Verifique o link de ativação e tente novamente mais tarde."
              }
            />
          );
        }
      })
      .catch((error) => {
        console.log(error);
        setalert(
          <AlertError
            text={
              "Houve algum problema durante a ativação do usuário. Tente novamente mais tarde."
            }
          />
        );
      });
  }, []);

  useEffect(() => {
    const search = location?.search;
    const params = new URLSearchParams(search);
    const token = params?.get("token")?.replace(/^(?:')(.*)(?:')$/, "$1") || "";
    const emailB64 = params?.get("email") || "";
    const buff = new Buffer(emailB64, "base64");
    const emailStr = buff?.toString("ascii");

    params?.delete("email");
    params?.delete("token");

    if (MaskAndValid?.validateEmail(emailStr) && token?.length > 0) {
      checkTokenAndEmail(emailStr, token);
    } else {
      setalert(
        <AlertError
          text={
            "E-mail ou token inválido(s). Verifique o link de ativação e tente novamente mais tarde."
          }
        />
      );
    }
  }, []);

  return (
    <>
      {alert}
      <Container maxWidth="md">
        <Card classes={{ root: classes.card }}>
          <CardContent classes={{ root: classes.cardContent }}>
            <Typography variant="h5" color="textSecondary" align="center">
              Ativando Usuário...
            </Typography>
          </CardContent>
        </Card>
      </Container>
    </>
  );
}

export default ActivateUser;
